<template>
  <div class="approval-page">
    <basic-container>
      <el-tabs v-model="activeTab" @tab-click="handleTabClick">
        <el-tab-pane label="待我审批" name="todo">
          <avue-crud
            ref="todoCrud"
            :option="todoOption"
            :data="tableData"
            :page="page"
            :table-loading="tableLoading"
            @on-load="handleList"
            @search-change="handleSearch"
            @search-reset="handleReset"
            @refresh-change="handleList"
            @size-change="handleSizeChange"
            @current-change="handlePageChange"
          >
            <template slot="status" slot-scope="scope">
              <el-tag :type="statusTagType(scope.row.status)" size="small">
                {{ statusLabel(scope.row.status) }}
              </el-tag>
            </template>
            <template slot="currentNodeOrder" slot-scope="scope">
              <span>{{ scope.row.currentNodeOrder }}/{{ scope.row.nodeCount }}</span>
            </template>
            <template slot="submitTime" slot-scope="scope">
              <span v-if="scope.row.submitTime">{{ displayTime(scope.row.submitTime) }}</span>
              <span v-else style="color: #c0c4cc">-</span>
            </template>
            <template slot="menu" slot-scope="scope">
              <el-button type="text" icon="el-icon-view" size="small" @click="handleView(scope.row)">
                去审批
              </el-button>
            </template>
          </avue-crud>
        </el-tab-pane>

        <el-tab-pane label="我已审批" name="done">
          <avue-crud
            ref="doneCrud"
            :option="doneOption"
            :data="tableData"
            :page="page"
            :table-loading="tableLoading"
            @on-load="handleList"
            @search-change="handleSearch"
            @search-reset="handleReset"
            @refresh-change="handleList"
            @size-change="handleSizeChange"
            @current-change="handlePageChange"
          >
            <template slot="status" slot-scope="scope">
              <el-tag :type="statusTagType(scope.row.status)" size="small">
                {{ statusLabel(scope.row.status) }}
              </el-tag>
            </template>
            <template slot="submitTime" slot-scope="scope">
              <span v-if="scope.row.submitTime">{{ displayTime(scope.row.submitTime) }}</span>
              <span v-else style="color: #c0c4cc">-</span>
            </template>
            <template slot="finishTime" slot-scope="scope">
              <span v-if="scope.row.finishTime">{{ displayTime(scope.row.finishTime) }}</span>
              <span v-else style="color: #c0c4cc">-</span>
            </template>
            <template slot="menu" slot-scope="scope">
              <el-button type="text" icon="el-icon-view" size="small" @click="handleView(scope.row)">
                查看
              </el-button>
            </template>
          </avue-crud>
        </el-tab-pane>

        <el-tab-pane label="我发起的" name="mine">
          <avue-crud
            ref="mineCrud"
            :option="mineOption"
            :data="tableData"
            :page="page"
            :table-loading="tableLoading"
            @on-load="handleList"
            @search-change="handleSearch"
            @search-reset="handleReset"
            @refresh-change="handleList"
            @size-change="handleSizeChange"
            @current-change="handlePageChange"
          >
            <template slot="status" slot-scope="scope">
              <el-tag :type="statusTagType(scope.row.status)" size="small">
                {{ statusLabel(scope.row.status) }}
              </el-tag>
            </template>
            <template slot="currentNodeOrder" slot-scope="scope">
              <span>{{ scope.row.currentNodeOrder }}/{{ scope.row.nodeCount }}</span>
            </template>
            <template slot="submitTime" slot-scope="scope">
              <span v-if="scope.row.submitTime">{{ displayTime(scope.row.submitTime) }}</span>
              <span v-else style="color: #c0c4cc">-</span>
            </template>
            <template slot="finishTime" slot-scope="scope">
              <span v-if="scope.row.finishTime">{{ displayTime(scope.row.finishTime) }}</span>
              <span v-else style="color: #c0c4cc">-</span>
            </template>
            <template slot="menu" slot-scope="scope">
              <el-button type="text" icon="el-icon-view" size="small" @click="handleView(scope.row)">
                查看
              </el-button>
              <el-button
                v-if="scope.row.status === 'PENDING'"
                type="text"
                icon="el-icon-close"
                size="small"
                style="color: #e6a23c"
                @click="handleCancel(scope.row)"
              >
                撤销
              </el-button>
              <el-button
                v-if="scope.row.status === 'REJECTED'"
                type="text"
                icon="el-icon-refresh-right"
                size="small"
                style="color: #409eff"
                @click="handleView(scope.row, true)"
              >
                重新编辑
              </el-button>
            </template>
          </avue-crud>
        </el-tab-pane>
      </el-tabs>
    </basic-container>

    <!-- 撤销原因弹窗 -->
    <el-dialog title="撤销审批" :visible.sync="cancelDialogVisible" width="480px" :close-on-click-modal="false">
      <el-form ref="cancelForm" :model="cancelForm" :rules="cancelRules" label-width="90px">
        <el-form-item label="撤销原因" prop="reason">
          <el-input
            v-model="cancelForm.reason"
            type="textarea"
            :rows="3"
            maxlength="200"
            show-word-limit
            placeholder="请输入撤销原因"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="cancelDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="submitting" @click="handleCancelSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { displayTime } from "@/util/util";
import {
  approvalTodoTableOption,
  approvalDoneTableOption,
  approvalMineTableOption,
  approvalStatusDic,
} from "@/const/work/waterProof/approvalOption";
import {
  findApprovalTodo,
  findApprovalDone,
  findApprovalMine,
  cancelApproval,
} from "@/api/work/waterProof/approval";

export default {
  name: "approvalCenter",
  data() {
    return {
      activeTab: "todo",
      todoOption: approvalTodoTableOption,
      doneOption: approvalDoneTableOption,
      mineOption: approvalMineTableOption,
      statusDic: approvalStatusDic,
      tableData: [],
      tableLoading: false,
      page: { total: 0, currentPage: 1, pageSize: 10 },
      searchParams: {},
      cancelDialogVisible: false,
      cancelForm: { instanceId: "", reason: "" },
      cancelRules: {
        reason: [{ required: true, message: "请输入撤销原因", trigger: "blur" }],
      },
      submitting: false,
    };
  },
  activated() {
    // 详情页有提交操作（通过/驳回/撤销/重新编辑提交）后返回列表时刷新数据
    if (this.$store && this.$store.state.common && this.$store.state.common.approvalNeedsRefresh) {
      this.$store.commit("SET_APPROVAL_NEEDS_REFRESH", false);
      this.handleList();
    }
  },
  methods: {
    displayTime,
    parseData(res) {
      if (!res || res.data == null) return {};
      if (typeof res.data === "string") {
        try {
          return JSON.parse(res.data) || {};
        } catch (e) {
          console.log("parseData error:", e);
          return {};
        }
      }
      return res.data;
    },
    statusLabel(val) {
      const item = this.statusDic.find((d) => d.value === val);
      return item ? item.label : val || "-";
    },
    statusTagType(val) {
      const map = {
        PENDING: "warning",
        APPROVED: "success",
        REJECTED: "danger",
        CANCELLED: "info",
        APPLY_FAILED: "danger",
      };
      return map[val] || "info";
    },
    buildParams() {
      // 分页 page 从 1 开始，直接透传
      const params = {
        page: this.page.currentPage,
        size: this.page.pageSize,
      };
      Object.keys(this.searchParams).forEach((k) => {
        const v = this.searchParams[k];
        if (v !== "" && v !== null && v !== undefined) params[k] = v;
      });
      return params;
    },
    handleList() {
      this.tableLoading = true;
      const apiMap = {
        todo: findApprovalTodo,
        done: findApprovalDone,
        mine: findApprovalMine,
      };
      apiMap[this.activeTab](this.buildParams())
        .then((res) => {
          if (res.code === "200") {
            const data = this.parseData(res);
            // 兼容两种返回结构：直接数组（[{...}]）或分页对象（{ rows, total }）
            if (Array.isArray(data)) {
              this.tableData = data;
              this.page.total = data.length;
            } else {
              this.tableData = data.rows || data.list || [];
              this.page.total = data.total || this.tableData.length;
            }
          } else {
            this.tableData = [];
            this.page.total = 0;
            this.$message.error(res.message || "加载失败");
          }
        })
        .catch((err) => {
          console.error("handleList error:", err);
          this.tableData = [];
          this.page.total = 0;
          this.$message.error("加载异常");
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    handleTabClick() {
      this.searchParams = {};
      this.page.currentPage = 1;
      this.handleList();
    },
    handleSearch(params) {
      this.searchParams = params || {};
      this.page.currentPage = 1;
      this.handleList();
    },
    handleReset() {
      this.searchParams = {};
      this.page.currentPage = 1;
      this.handleList();
    },
    handlePageChange(page) {
      this.page.currentPage = page;
      this.handleList();
    },
    handleSizeChange(size) {
      this.page.pageSize = size;
      this.page.currentPage = 1;
      this.handleList();
    },
    handleView(row, resubmitMode) {
      this.$router.push({
        path: `/work/waterProof/merchantPrice/approval/detail/${row.id}`,
        query: { resubmit: resubmitMode ? "1" : undefined },
      });
    },
    handleCancel(row) {
      this.cancelForm = { instanceId: row.id, reason: "" };
      this.cancelDialogVisible = true;
    },
    handleCancelSubmit() {
      this.$refs.cancelForm.validate((valid) => {
        if (!valid) return;
        this.submitting = true;
        cancelApproval(this.cancelForm)
          .then((res) => {
            if (res.code === "200") {
              this.$message.success("已撤销");
              this.cancelDialogVisible = false;
              this.handleList();
            } else {
              this.$message.error(res.message || "撤销失败");
            }
          })
          .catch((err) => {
            console.log("cancelApproval error:", err);
            this.$message.error("撤销异常");
          })
          .finally(() => {
            this.submitting = false;
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.approval-page {
  ::v-deep .el-tabs__header {
    margin-bottom: 8px;
  }
}
</style>
